
import { useState } from 'react';

import { Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Switch,
    TableContainer } from '@chakra-ui/react';


//data mora biti u formatu 
 const SmallMultiFilter=({data=[],selectedid=[],showheader=true,dataheader="",idfieldname="",textfieldname="",size='xs',onSelect})=> {
    const prepareData=()=>{
        if (data.length>0 & idfieldname!=="" & textfieldname!=="") {
            const _o=data[0];
            const _ar=Object.entries(_o);
            let _xId=-1;
            let _xNm=-1;
            
            for (let i = 0; i < _ar.length; i++) {
                if (_ar[i][0]===idfieldname) {
                    _xId=i;
                }
                if (_ar[i][0]===textfieldname) {
                    _xNm=i;
                }
            
            }
            if (_xId!==-1 & _xNm!==-1) {
                const _localdata=[];
                for (let i = 0; i < data.length; i++) {
                    const _s=new SmallMultiFilterData()
                    _s.id=(Object.entries(data[i])[_xId][1]).toString();
                    _s.text=Object.entries(data[i])[_xNm][1];
                    _localdata.push(_s);
                }
                return _localdata;
            }
        } else {
            return [];
        }
    }
    
    const [state]=useState(()=>{
        const _d=prepareData();
        return _d;
    });
    const [selected,setSelected]=useState(selectedid);

  
    

    const getTableHeader=()=>{
        if (showheader) {
            return (
                <Thead borderBottomColor={'grunt2.400'} borderBottomWidth={'1px'} borderBottomStyle={'solid'}>
                    <Tr>
                        <Th marginBottom={'30px'}><Switch size={'sm'} id={`swAll`} value={'swAll'} isChecked={SwitchAllChecked()} colorScheme='grunt2' onChange={SwitchValueChanged}></Switch></Th>
                        <Th marginBottom={'30px'} fontSize={size} textAlign={'center'}>{dataheader}</Th>
                    </Tr>
                </Thead>
            )
        }
    }
    const SwitchAllChecked=()=>{
        let _r=false;
        if (selected.length===state.length & selected.length>0) {
            _r=true;
        }
        return _r;
    }
    const SwitchValueChanged=(event)=>{
        const _s=[...selected];
        if (event.target.value==="swAll") {
            
            if (_s.length<state.length) {//dodaj sve
                _s.splice(0,_s.length);//isprazni sve
                for (let index = 0; index < state.length; index++) {
                    _s.push(state[index].id);
                }
            } else {
                _s.splice(0,_s.length);//isprazni sve
            }
        } else {
            const _id=event.target.value;
            const _ix=_s.indexOf(_id);
            if (_ix===-1) {
                _s.push(_id);
            } else {
                _s.splice(_ix,1);
            }
        
        }
        setSelected(_s);
        onSelect(_s);
    }

    return (
        <TableContainer padding={'2px'}>
            <Table variant='unstyled' size={size} cellSpacing={'5px'}>
                {getTableHeader()}
                <Tbody>
                    {state.map((item,index)=>{
                        return (
                            <Tr key={`row${index}`}>
                                <Td>
                                    <Switch size={'sm'} id={`sw_${item.id}`} value={item.id} isChecked={selected.includes(item.id)} colorScheme='grunt2' onChange={SwitchValueChanged}></Switch>
                                </Td>
                                <Td fontSize={size} textAlign={'center'}>{item.text}</Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        </TableContainer>
    )
}



class SmallMultiFilterData {
    constructor (selected=false,id="",text="") {
        this.selected=selected;
        this.id=id;
        this.text=text;
    }
}

export default SmallMultiFilter;